import React from "react";
import {Avatar, Box, Button, makeStyles, Typography} from "@material-ui/core";
import Image from "material-ui-image";
import Card from "@material-ui/core/Card";
import {colorGrayText} from "../../Constants/theme";
import {ReactComponent as LogoSVG} from "../../Images/logo.svg";

const useStyle = makeStyles(() => ({
    giftContainer: {
        width: 250,
    },
    giftText: {
        width: "100%",
        margin: "0 auto",
        height: "calc(100% - 148px)",
    },
    giftCard: {
        padding: "20px 20px 42px",
        marginBottom: "10px",
        height: "100%",
    },
    logo: {
        width: 250,
        height: 60,
        boxSizing: "border-box",
        position: "relative",
        backgroundColor: "#fafafa",
    },
    title: {
        color: colorGrayText,
        fontWeight: 700,
        fontSize: 16
    },
    text: {
        color: colorGrayText
    },
}));

interface GiftProps {
    selected: boolean,
    setSelected: () => void,
    giftDetails: string,
    companyDetails: string,
    imageUrl?: string,
    name: string,
}

const Gift: React.FC<GiftProps> = (
    {
        selected,
        setSelected,
        giftDetails,
        companyDetails,
        imageUrl,
        name,
    }) => {
    const classes = useStyle();

    return (
        <Box className={classes.giftContainer} marginTop="20px">
            <Box
                marginBottom="30px"
            >

                <Avatar variant="square" className={classes.logo}>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="250px"
                        height="60px"
                    >
                        {imageUrl ?
                            <Image
                                alt="pet image"
                                imageStyle={{
                                    objectFit: "contain",
                                }}
                                src={imageUrl}
                                errorIcon={<LogoSVG/>}
                                style={{width: "100%"}}

                            />
                            :
                            <LogoSVG/>
                        }
                    </Box>
                </Avatar>
            </Box>
            <Box className={classes.giftText}>
                <Card className={classes.giftCard}>
                    <Box marginBottom="25px">
                        <Typography className={classes.title}>
                            The gift:
                        </Typography>
                        <Typography className={classes.text}>
                            {giftDetails}
                        </Typography>
                    </Box>
                    <Typography className={classes.title}>
                        {`About ${name}`}
                    </Typography>
                    <Typography className={classes.text}>
                        {companyDetails}
                    </Typography>
                </Card>
                <Button
                    type="button"
                    variant={selected ? "contained" : "outlined"}
                    color="secondary"
                    fullWidth
                    onClick={setSelected}
                >
                    Select
                </Button>
            </Box>
        </Box>
    );
};

export default Gift;
